import { initializePrivacyFirstPostHog } from '@workspace/analytics/posthog/client';

initializePrivacyFirstPostHog({
  app: 'auth-app',
  key: process.env.NEXT_PUBLIC_POSTHOG_KEY,
});
